// extracted by mini-css-extract-plugin
export default {"collectStatus":"src-pages-Order-AllOrders-OrderDetail-ParcelProcess-Collected-css-module__collectStatus--begXp"};